import { Meta } from "entities/common";
import {
  CreateGatewayRequest,
  DetectGatewayModelResponse,
  GatewayItem,
  GatewayStatistics,
  RecognizeEuiResponse,
  UpdateGatewayRequest,
} from "entities/gateways";
import { DELETE, GET, PATCH, POST } from "utils/http";

const baseUrl = "/api/gateways";

// Don't let a 404 (route not yet deployed, or single resource missing)
// trigger the global redirect to PAGES.NOT_FOUND.
const noRedirect = { skipAuthRedirect: true };

export const getList = (query = "") =>
  GET<{ items: GatewayItem[] } & Meta>(`${baseUrl}${query}`, noRedirect);

export const getStatistics = () => GET<GatewayStatistics>(`${baseUrl}/statistics`, noRedirect);

export const getSensorCount = (id: number | string) =>
  GET<{ count: number }>(`${baseUrl}/${id}/sensor-count`, noRedirect);

export const getCurrent = (id: number | string) =>
  GET<GatewayItem>(`${baseUrl}/${id}`, noRedirect);

export const create = (body: CreateGatewayRequest) =>
  POST<CreateGatewayRequest, GatewayItem>(`${baseUrl}`, body, noRedirect);

export const update = (id: number | string, body: UpdateGatewayRequest) =>
  PATCH<UpdateGatewayRequest, GatewayItem>(`${baseUrl}/${id}`, body, noRedirect);

export const remove = (id: number | string) => DELETE(`${baseUrl}/${id}`, noRedirect);

export const detectModel = (eui: string) =>
  GET<DetectGatewayModelResponse>(`${baseUrl}/detect-model`, {
    ...noRedirect,
    params: { eui },
  });

export const recognizeEui = (file: File) => {
  const formData = new FormData();
  formData.append("file", file);
  return POST<FormData, RecognizeEuiResponse>(`${baseUrl}/recognize-eui`, formData, {
    ...noRedirect,
    headers: { "Content-Type": "multipart/form-data" },
  });
};
